import SearchResultContainer from "../../components/applications/searchResult";

const SearchResult = () => {
  return <SearchResultContainer />;
};

export default SearchResult;
